/* eslint-disable tss-unused-classes/unused-classes */
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  topText: {
    marginBottom: 20,
  },
  fieldRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: theme.spacing(0.5),
  },
  nameField: {
    flex: 1,
    marginRight: theme.spacing(2),
  },
  addressField: {
    marginRight: theme.spacing(2),
    width: '72%', // 72 to make up for the spacing not present here, but present in the row below (Ensures they align)
  },
  aptSuiteField: {
    width: 'auto',
    marginRight: theme.spacing(2),
  },
  cityField: {
    width: '50%',
    marginRight: theme.spacing(2),
  },
  stateField: {
    width: '20%',
    marginRight: theme.spacing(2),
    '& > .MuiFormControl-root': {
      margin: 0,
    },
  },
  zipCodeField: {
    width: 'auto',
    marginRight: theme.spacing(2),
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
  },
  statusIcon: {
    height: 24,
    color: theme.palette.warning.main,
  },
  ssnField: {
    minWidth: 172,
  },
  dateField: {
    margin: 0,
    marginRight: theme.spacing(2),
  },
  thumbsUp: {
    width: 175,
    height: 'auto',
  },
  verifyEmailSent: {
    width: 175,
    height: 'auto',
  },
  warningBox: {
    width: '100%',
    background: theme.palette.warning.light,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius * 2,
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
  },
  warningInner: {
    marginLeft: 5,
    display: 'flex',
    flexDirection: 'column',
  },
  infoIcon: {
    marginLeft: theme.spacing(1),
    color: theme.palette.info.light,
  },
  ssnInfoIcon: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(3),
    color: theme.palette.info.light,
  },
  termsLink: {
    textDecorationLine: 'none',
    color: theme.palette.primary.main,
    display: 'inline-flex',
    alignItems: 'center',
    '&:hover': {
      textDecorationLine: 'underline',
    },
  },
  displayNone: {
    display: 'none',
  },
  tooltipPlacementOne: {
    marginLeft: 2,
    marginTop: -2,
  },
  tooltipPlacementTwo: {
    marginLeft: 5,
    marginTop: -22,
  },
  tooltipLocation: {
    //  right: 10,
    //  marginLeft: -30,
    //  bottom: 10,
  },
  errorTab: {
    padding: `${theme.spacing(8)} ${theme.spacing(15)}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  errorWrapper: {
    color: 'inherit',
    fontSize: 'inherit',
  },
  errorCodeText: {
    color: 'inherit',
    fontStyle: 'italic',
    fontSize: 'inherit',
  },
  checkboxAlign: {
    alignSelf: 'flex-start',
    marginTop: -8,
  },
}));

export default useStyles;
